module.exports = __webpack_public_path__ + "static/img/Yummy Recipe.a9fdf92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cutemobi/imgs/browse/Yummy Recipe.jpg
// module id = 2237
// module chunks = 0